module.exports = function () {
  var $ = require('boxjs/dist/utils/_bdboxWrapper');
  /**
   * @file static/bdbox/utils/getInfoVersion.js
   * @author wangfupeng
  */

  /**
   * 返回资讯版的版本号
   *
   * @function
   * @return {string} version 返回资讯版的版本号
   * @author wangfupeng
   * @version  $Id: getInfoVersion.js 2017-08-18 wangfupeng
   */


  var self = function () {
    var back = 0;

    if ($.$isInfoBox()) {
      var ua = navigator.userAgent;
      var flag;

      if (flag = /baiduboxapp\/([\d+.]+)/.exec(ua)) {
        back = flag[1];
      }
    }

    self = function () {
      return back;
    };

    return back;
  };

  return self;
}();